import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';
import './FilterSwipeDialog.css';

export const FilterSwipeDialog = ({ 
    children, 
    isLoading = false, 
    onClearFilters,
    className = ''
}) => {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);
    const [dragStartY, setDragStartY] = useState(0);
    const [isDragging, setIsDragging] = useState(false);
    const [dialogDragStartY, setDialogDragStartY] = useState(0);
    const [isDialogDragging, setIsDialogDragging] = useState(false);

    const openDialog = () => setVisible(true);
    const closeDialog = () => setVisible(false);

    // Handlers pour ouvrir le dialog en glissant vers le haut
    const handleTouchStart = (e) => {
        setDragStartY(e.touches[0].clientY);
        setIsDragging(true);
    };

    const handleTouchMove = (e) => {
        if (!isDragging) return;
        const currentY = e.touches[0].clientY;
        const diff = dragStartY - currentY;
        
        if (diff > 50) {
            setVisible(true);
            setIsDragging(false);
        }
    };

    const handleTouchEnd = () => {
        setIsDragging(false);
    };

    // Handlers pour fermer le dialog en glissant vers le bas
    const handleDialogTouchStart = (e) => {
        setDialogDragStartY(e.touches[0].clientY);
        setIsDialogDragging(true);
    };

    const handleDialogTouchMove = (e) => {
        if (!isDialogDragging) return;
        const currentY = e.touches[0].clientY;
        const diff = currentY - dialogDragStartY;
        
        if (diff > 100) {
            setVisible(false);
            setIsDialogDragging(false);
        }
    };

    const handleDialogTouchEnd = () => {
        setIsDialogDragging(false);
    };

    const headerTemplate = () => {
        return (
            <div 
                className='fsd-header'
                onTouchStart={handleDialogTouchStart}
                onTouchMove={handleDialogTouchMove}
                onTouchEnd={handleDialogTouchEnd}
            >
                <div className="fsd-header-drag-handle"></div>
                <div className="fsd-header-title-row">
                    <span className="fsd-header-title">Filtres</span>
                    {isLoading && (
                        <span className="fsd-loading-text">
                            <i className="pi pi-spin pi-spinner" style={{ fontSize: '0.75rem', marginRight: '0.25rem' }}></i>
                            MISE À JOUR...
                        </span>
                    )}
                    <button 
                        className="fsd-reset-button"
                        onClick={onClearFilters}
                    >
                        Réinitialiser
                    </button>
                </div>
            </div>
        );
    };

    return (
        <>
            {/* Barre de swipe pour ouvrir les filtres - cachée quand le dialog est ouvert */}
            {!visible && (
                <div 
                    className="filter-swipe-bar"
                    onClick={openDialog}
                    onTouchStart={handleTouchStart}
                    onTouchMove={handleTouchMove}
                    onTouchEnd={handleTouchEnd}
                >
                    <div className="filter-swipe-bar__handle"></div>
                    <div className="filter-swipe-bar__content">
                        <span className="filter-swipe-bar__icon">▲</span>
                        <span className="filter-swipe-bar__text">{t('general.filters').toUpperCase()}</span>
                    </div>
                </div>
            )}

            {/* Dialog des filtres */}
            <Dialog
                className={`filter-dialog-mobile ${className}`}
                header={headerTemplate}
                visible={visible}
                onHide={closeDialog}
                dismissableMask
                modal
                closable={false}
                position="bottom"
                blockScroll={true}
            >
                {children}
            </Dialog>
        </>
    );
};
